/**
 * Component Entry
 *
 */

import Heading from './Heading'
export default Heading
export * from './Heading'
